export default "__VITE_ASSET__CHuM1wa$__"